import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Head } from '~/components/shared/Head';
import Image404 from '~/assets/404.webp';

function Page404() {
  const [t] = useTranslation('app');
  return (
    <>
      <Head title={'The page is not found'}></Head>
      <div className="hero min-h-screen">
        <div className="hero-content text-center text-3xl font-bold">
          <div className="flex flex-col items-center">
            <img src={Image404} alt="404" className="mb-6 w-96 rounded-lg" />
            <h1 className="mb-4">{t('not_found_title')}</h1>
            <p className="text-sm font-light">{t('not_found_subtitle')}</p>
            <div className="mt-4">
              <Link to="/" className="link-primary text-[1.4rem]">
                {t('go_home')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Page404;
